<script setup lang="ts">
    import { onMounted } from 'vue';
    import PageHeader from '../components/PageHeader.vue';
    import RadioSelection from '../components/RadioSelection.vue';
    import { __ } from '../stores/expressions';

    import { useLibraryStore } from '../stores/library';
    import WidgetLibrary from '../components/library/WidgetLibrary.vue';
    import DashboardLibrary from '../components/library/DashboardLibrary.vue';
    import TextInput from '../components/TextInput.vue';
    import { BookmarkIcon, SearchIcon } from '@lucide/vue';

    const library = useLibraryStore();

    const libraryPageOptions = [
        { value: 'widget', label: __('widgets') },
        { value: 'dashboard', label: __('dashboards') },
    ];

    onMounted(() => {
        library.getWidgets();
        library.getDashboards();
    });

    const handlePageChange = (page: string) => {
        library.page = page as 'widget' | 'dashboard';
        library.searchFilter = '';
    };
</script>
<template>
    <div class="page-padding flex flex-col gap-1">
        <PageHeader>
            <template #icon><BookmarkIcon class="size-full" /></template>
            <div class="flex gap-4 items-baseline">
                <h1 class="heading-xl">
                    {{ __('library') }}
                </h1>
                <p class="text-body">
                    {{ __('library-header-text') }}
                </p>
            </div>
        </PageHeader>
        <div class="bg-white rounded-lg shadow-md p-8">
            <div class="flex flex-col lg:flex-row gap-4 mb-4 justify-between">
                <div>
                    <TextInput
                        v-model="library.searchFilter"
                        :placeholder="
                            library.page === 'dashboard'
                                ? __('library-search-dashboard-placeholder')
                                : __('library-search-widget-placeholder')
                        "
                        class="w-100"
                    >
                        <template #end-adornment><SearchIcon /></template>
                    </TextInput>
                </div>
                <div>
                    <RadioSelection
                        :options="libraryPageOptions"
                        :selected="library.page"
                        @select="handlePageChange"
                    />
                </div>
            </div>
            <WidgetLibrary
                v-if="library.page === 'widget'"
                :widgets="library.widgets"
                :search-string="library.searchFilter"
            />
            <DashboardLibrary
                v-if="library.page === 'dashboard'"
                :dashboards="library.dashboards"
                :search-string="library.searchFilter"
            />
        </div>
    </div>
</template>
